import WizardCard from './WizardCard.jsx';
import { formatTime12h } from '../../lib/dates.js';

export default function StepConfirmation({
  briefing,
  calendarBlocks,
  onBack,
  onFinish,
}) {
  return (
    <WizardCard
      step={7}
      title="Ready to start the day?"
      subtitle="Confirm and the dashboard switches to Full Dash."
      onBack={onBack}
      onNext={onFinish}
      nextLabel="Let's go"
    >
      <dl className="space-y-3 text-sm">
        <Row label="Devotional" value={booleanLabel(briefing.devotional)} />
        <Row label="Workout" value={booleanLabel(briefing.workout)} />
        <Row label="Bed time" value={formatTime12h(briefing.bed_time)} />
        <div>
          <div className="text-xs uppercase tracking-wider text-text-secondary mb-1.5">
            Today's MITs
          </div>
          <ul className="space-y-1.5">
            {[1, 2, 3].map((i) => {
              const text = briefing[`mit_${i}_text`];
              const block = calendarBlocks?.find((b) => b.text === text);
              return (
                <li key={i} className="flex items-start gap-2 text-text-primary">
                  <span className="text-text-muted mt-0.5">{i}.</span>
                  <span className="flex-1">
                    {text}
                    {block?.asBlock && block.time && (
                      <span className="ml-2 text-xs text-accent-blue">
                        · block @ {formatTime12h(block.time)}
                      </span>
                    )}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </dl>
    </WizardCard>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between">
      <dt className="text-text-secondary">{label}</dt>
      <dd className="text-text-primary">{value}</dd>
    </div>
  );
}

function booleanLabel(v) {
  if (v === true) return 'Yes';
  if (v === false) return 'No';
  return '—';
}
